import { useState, useCallback } from 'react';
import type { UserSuggestion } from '../types';

const STORAGE_KEY = 'netview_recent_searches';
const MAX_RECENT = 5;

interface UseRecentSearchesResult {
  recentSearches: UserSuggestion[];
  addRecentSearch: (user: UserSuggestion) => void;
  clearRecentSearches: () => void;
}

function loadRecents(): UserSuggestion[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.slice(0, MAX_RECENT);
  } catch {
    return [];
  }
}

export function useRecentSearches(): UseRecentSearchesResult {
  const [recentSearches, setRecentSearches] = useState<UserSuggestion[]>(loadRecents);

  const addRecentSearch = useCallback((user: UserSuggestion) => {
    setRecentSearches((prev) => {
      const filtered = prev.filter((s) => s.email !== user.email);
      const updated = [user, ...filtered].slice(0, MAX_RECENT);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
      return updated;
    });
  }, []);

  const clearRecentSearches = useCallback(() => {
    setRecentSearches([]);
    localStorage.removeItem(STORAGE_KEY);
  }, []);

  return { recentSearches, addRecentSearch, clearRecentSearches };
}
